module.exports = __webpack_public_path__ + "img/ch12_01_生日厨房.40b2a58c.jpg";